import React from 'react';
import CSVReader from './Components/CSVReader';

function App() {
  return (
    <div className="App">
      <CSVReader />
    </div>
  );
}

export default App;